module.exports = __webpack_public_path__ + "media/sqk.e4aab2cb.mp4";